import { useEffect } from 'react'

// Enquanto `active`, o navegador pergunta antes de fechar/recarregar a aba (G2). O fluxo desliga o
// guard (fase "finishing"/"error") ANTES de chamar clearCache()/navegar, senão o próprio reload pediria confirmação.
export default function useBeforeUnloadGuard(active) {
  useEffect(() => {
    if (!active) return undefined
    const handler = (e) => {
      e.preventDefault()
      e.returnValue = ''
      return ''
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [active])
}
